<link rel="preload" fetchpriority="high" as="image"
  href="https://d1we2hgzmci25y.cloudfront.net/assets/img/b2b_sign-up-mobile-header.webp" type="image/webp">
<div class="bg-affiliate">
  <div class="shippn-homepage-container margin-auto padding-ver-15">
    <div class="row">
      <div class="col-md-12">

        <div class="become-a-b2b-banner">
          <div class="become-a-b2b-banner-content">
            <h1 class="become-a-b2b-banner-content-title">Simplify your international shipping process with Shippn</h1>
            <div class="become-a-b2b-banner-content-boxes">
              <div class="become-a-b2b-banner-content-boxes-box become-a-b2b-banner-content-boxes-partner">
                <img src="/assets/img/become-an-b2b/delivery.svg" alt="Shippn Parnet Icon" class="affiliate-box-icon"
                  height="40">
                <span class="shippn-orange text-bold">1-5 Days</span>
                <span class="font-size-14 m-font-size-12">Delivery</span>
              </div>
              <div class="become-a-b2b-banner-content-boxes-box become-a-b2b-banner-content-boxes-users">
                <img src="/assets/img/become-an-b2b/carriers.svg" alt="Shippn Profile Icon" class="affiliate-box-icon"
                  height="40">
                <span class="shippn-orange text-bold">Reputable</span>
                <span class="font-size-14 m-font-size-12">Carriers</span>
              </div>
              <div class="become-a-b2b-banner-content-boxes-box become-a-b2b-banner-content-boxes-basket">
                <img src="/assets/img/become-an-b2b/discounts.svg" alt="affilate basket icon" class="affiliate-box-icon"
                  height="40">
                <span class="shippn-orange text-bold">Special</span>
                <span class="font-size-14 m-font-size-12">Discounts</span>
              </div>
              <div class="become-a-b2b-banner-content-boxes-box become-a-b2b-banner-content-boxes-package">
                <img src="/assets/img/become-an-b2b/account.svg" alt="Shippn Order Icon" height="40"
                  class="affiliate-box-icon">
                <span class="shippn-orange text-bold">Account </span>
                <span class="font-size-14 m-font-size-12">Representative</span>
              </div>
            </div>
          </div>

        </div>



        <div class="become-a-b2b-sign-up">
          <h2 class="become-a-b2b-sign-up-title">Create Your B2B Account</h2>
        </div>

        <div style="margin-bottom: 30px;" class="hide-for-desktop">
          <img src="/assets/img/become-an-b2b/shippn-b2b-content-deal-image.webp" alt="Shippn B2B Deal Image"
              class="become-a-b2b-deal-content-image">
          <p style="max-width: 800px; margin:auto; text-align:center;">
            Unlock great shipping rates with seamless express delivery. Welcome customers around the globe, making your
            products accessible to anyone, anywhere.
          </p>
        </div>

        <div class="b2b-main-content-wrapper">
          <div class="become-a-b2b-form-wrapper">

            <!-- Short description ekle-->

            <form ngNativeValidate [formGroup]="form">
              <div class="row">
                <div style="margin-top: 15px;" class="col-md-6">
                  <div id="input_container">
                    <input (keypress)="keyPressAlphabethic($event)" id="only-text" formControlName="firstName"
                      [ngClass]="{'shippn-border-red':form.get('firstName').touched && form.get('firstName').invalid}"
                      type="text" name="first-name" required minlength="2" class="form-control shippn-input bg-white"
                      placeholder="First Name">
                    <i *ngIf="form.get('firstName').touched && form.get('firstName').invalid" id="input_img"
                      class="fas fa-times"></i>

                  </div>
                </div>
                <div style="margin-top: 15px;" class="col-md-6">
                  <div id="input_container">
                    <input (keypress)="keyPressAlphabethic($event)" name="signupSurname" formControlName="lastName"
                      required minlength="2" type="text"
                      [ngClass]="{'shippn-border-red':form.get('lastName').touched && form.get('lastName').invalid}"
                      class="form-control shippn-input bg-white " placeholder="Last Name">
                    <i *ngIf="form.get('lastName').touched && form.get('lastName').invalid" id="input_img"
                      class="fas fa-times"></i>
                  </div>
                </div>
              </div>
              <div class="row">
                <div style="margin-top: 15px;" class="col-md-6">
                  <div class="input_container">
                    <input style="padding-right: 35px;" formControlName="email"
                      [ngClass]="{'shippn-border-red':form.get('email').touched && form.get('email').invalid}" required
                      type="email" class="form-control shippn-input bg-white " placeholder="Email Address">
                    <i style="right: 19px;" *ngIf="form.get('email').touched && form.get('email').invalid"
                      id="input_img" class="fas fa-times"></i>
                  </div>
                </div>
                <div style="margin-top: 15px;" class="col-md-6">
                  <div class="select--wrapper bg-white b-rad-5">
                    <i class="fas fa-chevron-down"
                      style="position: absolute; right: 20px; top: 11px;float: right; color: #222222; border-radius: 32%; padding: 7px; font-size: 12px;"
                      aria-hidden="true"></i>
                    <select formControlName="country"
                      style="-webkit-appearance: none;-moz-appearance: none;appearance: none;width: 100%; border-radius: 5px;padding:10px 15px !important;height: 43px;"
                      class="form-select  shippn-input" class="form-control-sm" aria-label=".form-select-lg example">
                      <option *ngFor="let country of counrtyList;" value="{{country.code}}">
                        <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                        <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
                      </option>
                    </select>
                  </div>

                </div>
              </div>

              <div class="row">
                <div class="col-md-6" style="margin-top: 15px;">
                  <div class="input_container">
                    <input style="padding-right: 35px;" formControlName="company_name"
                      [ngClass]="{'shippn-border-red':form.get('company_name').touched && form.get('company_name').invalid}"
                      required type="text" class="form-control shippn-input bg-white " placeholder="Company Name">

                  </div>
                </div>
                <div class="col-md-6" style="margin-top: 15px;">
                  <div class="input_container">
                    <input style="padding-right: 35px;" formControlName="vat_number"
                      [ngClass]="{'shippn-border-red':form.get('vat_number').touched && form.get('vat_number').invalid}"
                      required type="text" class="form-control shippn-input bg-white " placeholder="VAT Number">

                  </div>
                </div>
              </div>

              <!-- Business Desc-->
              <div class="row">
                <div style="margin-top: 15px;" class="col-md-12">
                  <div class="input_container">
                    <textarea name="" id="" cols="30" rows="5" class="form-control shippn-input bg-white"
                      [ngClass]="{'shippn-border-red':form.get('b2b_short_description').touched && form.get('b2b_short_description').invalid}"
                      placeholder="Short description about your business (Monthly volume, contents, top destinations, average weight)"
                      formControlName="b2b_short_description"></textarea>
                    <span class="become-a-b2b-short-description-char-length"
                      [ngClass]="{'color-red':(form.get('b2b_short_description').touched && form.get('b2b_short_description').invalid) || form.get('b2b_short_description').value.length > 400}">{{form.get('b2b_short_description').value.length}}/400</span>
                  </div>
                </div>
              </div>



              <div class="row">
                <!-- Password -->
                <div class="col-md-6" style="margin-top: 15px;">
                  <div class="input_container password_container">
                    <input formControlName="password"
                      [ngClass]="{'shippn-border-red':form.get('password').touched && form.get('password').invalid || form.errors?.passwordsDoNotMatch}"
                      name="signupPassword" required type="password" class="form-control shippn-input bg-white"
                      placeholder="Password" minlength="6" (keyup)="writingPassword($event)"
                      autocomplete="one-time-code">


                    <i style="right: 19px; top: 12px;"
                      *ngIf="form.get('password').touched && form.get('password').invalid" id="input_img"
                      class="fas fa-times password-i"></i>

                    <p style="font-size: 12px; margin: 0;"
                      *ngIf=" form.get('password').value?.length < 6 && (form.get('password').touched && form.get('password').invalid)">
                      Password must be at least 6 characters.
                    </p>

                    <p *ngIf=" form.get('password').value?.length >= 6 && (form.get('repassword').touched && form.get('password').touched) && form.errors?.passwordsDoNotMatch"
                      style="font-size: 12px; margin: 0;">
                      Passwords do not match
                    </p>
                  </div>
                </div>
                <!-- Re-->
                <div class="col-md-6 repassword" style="margin-top: 15px;">
                  <div class="input_container password_container">
                    <input formControlName="repassword"
                      [ngClass]="{'shippn-border-red':form.get('repassword').touched && form.get('repassword').invalid || form.errors?.passwordsDoNotMatch}"
                      name="signupRePassword" minlength="6" required type="password"
                      class="form-control shippn-input bg-white " placeholder="Retype Password"
                      (keyup)="writingRePassword($event)" autocomplete="one-time-code">
                    <i style="right: 19px; bottom: 26px;"
                      *ngIf="form.get('repassword').touched && form.get('repassword').invalid" id="input_img"
                      class="fas fa-times password-i"></i>
                    <p style="font-size: 12px; margin: 0;"
                      *ngIf=" form.get('repassword').value?.length < 6 && (form.get('repassword').touched && form.get('repassword').invalid)">
                      Password must be at least 6 characters.
                    </p>

                    <p *ngIf=" form.get('repassword').value?.length >= 6 && (form.get('repassword').touched && form.get('password').touched) && form.errors?.passwordsDoNotMatch"
                      style="font-size: 12px; margin: 0;">
                      Passwords do not match
                    </p>
                  </div>
                </div>
                <!-- Password -->

              </div>
              <div class="col-md-12">
                <password-strength-meter [password]="password"></password-strength-meter>
              </div>
              <div class="row">
                <div style="margin-top: 15px;" class="col-md-12">
                  <div style="display: inline-flex; align-items: center;" class="form-check">
                    <input formControlName="mail_permission" style="width: 27px;height: 27px;margin-top: 0;"
                      class="form-check-input" type="checkbox" id="defaultCheck1">
                    <label style="margin-left: 15px;" class="form-check-label" for="defaultCheck1">
                      <p style="font-weight: 400;font-size: 13px;color: #000000a6;margin-bottom: 0;">I Would like to
                        receive coupons, promotions, and updates via email or
                        phone from Shippn.</p>

                    </label>
                  </div>
                  <div style="display: inline-flex; margin-top: 20px; align-items: center;" class="form-check">
                    <input formControlName="acceptance_terms" style="width: 27px;height: 27px;margin-top: 0;"
                      class="form-check-input" type="checkbox" id="defaultCheck1">
                    <label style="margin-left: 15px;" class="form-check-label" for="defaultCheck1">
                      <p style="font-weight: 400;font-size: 13px;color: #000000a6;margin-bottom: 0;">I
                        accept the <a style="color: #007bff;cursor: pointer;" data-toggle="modal"
                          data-target="#userAgreementModal">Shipping Provider Agreement</a> & <a
                          style="color: #007bff;cursor: pointer;" data-toggle="modal"
                          data-target="#privacyModal">Privacy
                          Policy.</a></p>

                    </label>
                  </div>
                </div>
                <div style="margin-top: 15px;" class="col-lg-12 col-md-12">
                  <ngx-recaptcha2 #captchaElem [siteKey]="googleRecapthaSiteKey" [useGlobalDomain]="false"
                    formControlName="recaptcha">
                  </ngx-recaptcha2>
                  <span *ngIf="form.get('recaptcha').touched && form.get('recaptcha').invalid"
                    style="color: red;font-size: 14px;">This field is required.</span>
                </div>
                <div style="margin-top: 15px;" class="col-md-12">
                  <button *ngIf="!passingSignupData" (click)="completeStep1()"
                    style="background-color: #ff6c36;padding: 12px 12px;border: #ff6c36;color: white;width: 100%;font-weight: 600;"
                    type="submit" class="btn">CREATE MY B2B ACCOUNT</button>

                  <a *ngIf="passingSignupData"
                    style="background-color: #ff6c36;padding: 22px 12px;border: #ff6c36;color: white;width: 100%;font-weight: 600;"
                    class="btn btn-loading-white"></a>
                </div>
              </div>
            </form>

          </div>

          <div class="become-a-b2b-deal-content">
            <h4 class="text-center">Expand your reach across borders!</h4>
            <img src="/assets/img/become-an-b2b/shippn-b2b-content-deal-image.webp" alt="Shippn B2B Deal Image"
              class="become-a-b2b-deal-content-image">
            <div class="become-a-b2b-benefit">
              <strong>Effortless shipping within minutes</strong>
              <span>You can generate shipping labels and have them ready for pickup</span>
            </div>
            <div class="become-a-b2b-benefit">
              <strong>Competitive Rates</strong>
              <span>Through our strategic partnerships with leading carriers, we offer highly competitive shipping rates</span>
            </div>
            <div class="become-a-b2b-benefit">
              <strong>Swift delivery within 1-5 days</strong>
              <span>Your international customers can receive their orders within 1-5 days.</span>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="termsModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div style="max-width: 800px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Terms & Conditions</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <b2b-terms-content [textColorClass]="'black-text'" [maxHeight]="500"></b2b-terms-content>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


<!-- Modal -->
<div class="modal fade" id="userAgreementModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div style="max-width: 800px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">SHIPPING PROVIDER AGREEMENT</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <b2b-terms-content [textColorClass]="'black-text'" [maxHeight]="500"></b2b-terms-content>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- Privacy Modal-->
<div class="modal fade" id="privacyModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div style="max-width: 800px;" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Privacy Policy</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <privacy-content [maxHeight]="500" [textColorClass]="'black-text'"></privacy-content>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- Privacy Modal-->